import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { InterfaceProvider } from './context/InterfaceProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <InterfaceProvider>
        <App />
      </InterfaceProvider>
    </AuthProvider>
  </React.StrictMode>
);

